import * as types from './constants';

export const resetGlobalState = () => ({
    type: types.RESET_GLOBAL_STATE,
});
